import React from "react";
import { Helmet } from "react-helmet-async";

const GlobalHelmetProvider = ({ title, description }: { title: string; description?: string }) => {
  return (
    <Helmet>
      {title && <title>Josh Brett | {title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default GlobalHelmetProvider;
